import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseCreateCompanyUserCard {
  companyUserId?: string,
  onSuccess?: () => void,
}

const useCreateCompanyUserCard = ({ companyUserId, onSuccess }: UseCreateCompanyUserCard) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createCompanyUserCard'],
    mutationFn: async () => {
      return privateAxios.post(`/client/users/${companyUserId}/request_card`)
    },
    onSuccess,
  })
}

export default useCreateCompanyUserCard